<footer id="footer" class="page-footer">
    <div class="container">
        <div id="contact-info" class="px-2 px-sm-3">
            <div class="row">
                <div class="col-6 col-md-4 col-lg-4">
                    <h3>Kontakt</h3>
                    <a href="{{env.kontakt.web}}"><i>{{env.kontakt.web}}</i></a>
                </div>
                <div class="col-6 col-md-4 col-lg-4">
                    <p>
                        <b>E-post</b>
                    </p>
                    <p>
                        <a href="mailto:{{env.kontakt.epost}}">{{env.kontakt.epost}}</a>
                    </p>
                </div>
                <div class="col-6 col-md-4 col-lg-4">
                    <p>
                        <b>Telefon</b>
                    </p>
                    <p>
                        {{env.kontakt.telefon}}
                    </p>
                </div>
            </div>
        </div>
        <div id="links" class="socialmedia-row px-2 px-sm-3">
            <div id="powered-by" class="text-lg-end">
                <a href="https://www.otimo.se/" target="_blank">
                    Powered by<i class="ms-2"></i>
                    <img src="assets/images/OTIMO_logo_vit.svg"
                            onerror="this.onerror = null;this.src = 'assets/images/OTIMO_logo_vit-500px.png'"
                            alt="Otimo Data AB (logotyp)" title="{{version}}"/>
                </a>
            </div>
        </div>
    </div>
</footer>
